import jbAPI from "./jobboard";

console.log("empoyer api ");

export const fetchCandidateDetailbyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/candidate/${candidate_id}/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

export const updateBasicInfo = async (appUserId, candidatePayload, token) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // If payload is FormData, set correct Content-Type
    if (candidatePayload instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    const response = await jbAPI.put(
      `/jobseeker/profile/${appUserId}`,
      candidatePayload,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to update candidate detail:", error);
    throw error;
  }
};


// Candidate Skills

export const fetchCandidateSkillbyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/skills/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

// Candiadate Experiences

export const fetchCandidateExperiencebyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/experiences/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

// Candidate Education

export const fetchCandidateEducationsbyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/educations/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

export const deleteResume = async (appUserId, token) => {
  try {
    const response = await jbAPI.delete(`/jobseeker/profile/${appUserId}/resume`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to delete resume:", error);
    throw error;
  }
};
